import colorByOwnerType from './colorByOwnerType'
import { parzToExclude } from '../config/config'
import getMainOwner from './getMainOwner'

const styleFeature = (owner) => {
  const styles = {
    fillColor: undefined,
    strokeOpacity: 0,
    fillOpacity: 0.5,
    clickable: true,
    zindex: 1
  }

  if (owner[0] != null && owner.length > 0) {
    const owners = owner.map((element, index) => {
      if (index === 0) {
        return element['eigentuemer-code']
      }
      if (index > 0 && element.ownerhash !== owner[index - 1].ownerhash) {
        return element['eigentuemer-code']
      }
      return null
    })

    const ownerType = parseInt(getMainOwner(owners), 10)

    if (
      owner[0].code2 === 13 ||
      parzToExclude.includes(owner[0]['grundstueck-nr'])
    ) {
      styles.fillColor = null
      styles.strokeOpacity = 0
      styles.fillOpacity = 0
      styles.clickable = false
    } else {
      styles.fillColor = colorByOwnerType(ownerType)
      styles.strokeOpacity = 1
    }
  } else {
    styles.fillColor = null
    styles.strokeOpacity = 0.2
    styles.fillOpacity = 0.0
    styles.clickable = false
  }

  if (owner.parzart === 'SDR') {
    styles.zindex = 2
  } else {
    styles.zindex = 1
  }

  return styles
}

export default styleFeature



// WEBPACK FOOTER //
// ./src/logic/styleFeature.js